/// <amd-module name="SuiteCommerce.GridOrder.MatrixChildItem.Prototype"/>
define("SuiteCommerce.GridOrder.MatrixChildItem.Prototype", ["require", "exports", "SuiteCommerce.GridOrder.Common.DependencyProvider", "SuiteCommerce.GridOrder.Utils", "SuiteCommerce.GridOrder.Instrumentation", "SuiteCommerce.GridOrder.Configuration", "grid_order_cell_matrix_child_item.tpl"], function (require, exports, DependencyProvider_1, Utils_1, Instrumentation_1, GridOrder_Configuration_1, matrixChildItemTemplate) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var MatrixChildItemViewPrototype = /** @class */ (function () {
        function MatrixChildItemViewPrototype() {
        }
        Object.defineProperty(MatrixChildItemViewPrototype.prototype, "template", {
            get: function () {
                return matrixChildItemTemplate;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatrixChildItemViewPrototype.prototype, "events", {
            get: function () {
                return {
                    'change .grid-order-cell-matrix-child-item-quantity': 'quantityChanged',
                    'click .grid-order-stock-info-back-in-stock-button': 'openStockNotificationsComponent'
                };
            },
            enumerable: true,
            configurable: true
        });
        MatrixChildItemViewPrototype.prototype.quantityChanged = function (event) {
            var quantityInputElementValue = jQuery(event.currentTarget).val() || '0';
            var quantity = parseInt(quantityInputElementValue, 10);
            this.model.quantity = quantity;
            if (this.model.quantityIsValid()) {
                this.clearErrorMessage(event);
            }
            else {
                this.showErrorMessage(event);
            }
        };
        MatrixChildItemViewPrototype.prototype.openStockNotificationsComponent = function () {
            var stockNotificationsComponent = this.container.getComponent('StockNotifications');
            var matrixChildItemInternalId = this.model.internalId;
            var matrixParentItemInternalId = this.model.parentInternalId;
            if (stockNotificationsComponent) {
                if (stockNotificationsComponent.showSubscriptionModal) {
                    try {
                        stockNotificationsComponent.showSubscriptionModal({
                            selectedProductId: matrixChildItemInternalId,
                            matrixParentId: matrixParentItemInternalId,
                            modalTitle: Utils_1.Utils.translate('Subscribe to $(0)', this.model.itemId),
                        });
                    }
                    catch (e) {
                        console.log(e);
                    }
                }
                else {
                    stockNotificationsComponent.showSuscriptionModal(matrixChildItemInternalId, matrixParentItemInternalId);
                }
                var stockNotificationsUsageRequestLog = Instrumentation_1.default.getLog('stockNotificationsUsageRequestLog');
                stockNotificationsUsageRequestLog.setParameters({
                    activity: 'SC Stock Notifications usage from SC Grid Order',
                });
                stockNotificationsUsageRequestLog.submit();
            }
        };
        MatrixChildItemViewPrototype.prototype.clearErrorMessage = function (event) {
            var $quantityInputField = jQuery(event.currentTarget);
            $quantityInputField.removeClass('data-validation-error');
            $quantityInputField.removeAttr('data-toggle');
            // @ts-ignore
            $quantityInputField.tooltip('hide');
            // @ts-ignore
            $quantityInputField.tooltip('destroy');
        };
        MatrixChildItemViewPrototype.prototype.showErrorMessage = function (event) {
            var $quantityInputField = jQuery(event.currentTarget);
            $quantityInputField.addClass('data-validation-error');
            $quantityInputField.attr('data-toggle', 'grid-order-tooltip');
            // @ts-ignore
            $quantityInputField.tooltip('destroy');
            // @ts-ignore
            $quantityInputField.tooltip({
                title: this.model.getErrorMessage(),
                placement: 'bottom',
            });
        };
        MatrixChildItemViewPrototype.prototype.isBackInStockNotificationIsEnabled = function () {
            return !this.model.isInStock
                && !this.model.isBackorderable
                && !!this.container.getComponent('StockNotifications')
                && this.model.isBackInStockNotificationEnabled;
        };
        MatrixChildItemViewPrototype.prototype.isQuantityInputEnabled = function () {
            return !!this.model.isInStock || !!this.model.isBackorderable;
        };
        MatrixChildItemViewPrototype.prototype.getContext = function () {
            var price = '0';
            if (!DependencyProvider_1.ProfileModel.getInstance().hidePrices()) {
                var onlineCustomerPriceDetail = this.model.onlineCustomerPriceDetails;
                price = onlineCustomerPriceDetail ? onlineCustomerPriceDetail.onlinecustomerprice_formatted : '0';
            }
            return {
                price: price,
                internalId: this.model.internalId,
                itemId: this.model.itemId,
                isInStock: this.model.isInStock,
                showOutOfStockMessage: this.model.showOutOfStockMessage,
                outOfStockMessage: this.model.outStockMessage,
                showStockInformation: this.model.showStockInformation,
                stockInformationText: this.model.stockInformationText,
                quantityInputIsEnabled: this.isQuantityInputEnabled(),
                backInStockNotificationIsEnabled: this.isBackInStockNotificationIsEnabled(),
                combinationNotAvailableLabel: GridOrder_Configuration_1.GridOrderConfiguration.combinationNotAvailable,
                stockNotificationsButtonLabel: GridOrder_Configuration_1.GridOrderConfiguration.stockNotificationsLabel,
            };
        };
        return MatrixChildItemViewPrototype;
    }());
    exports.MatrixChildItemViewPrototype = MatrixChildItemViewPrototype;
});
